import {
  isStrongPassword,
  isAlphanumeric,
  isEmpty,
  isWhitelisted,
  isEmail,
  isDate,
  isAfter,
  isBefore,
  isNumeric,
  isFloat,
  isInt,
  isAscii,
  matches,
  isLength
} from 'validator';

/* Validator */
/* valdnUserPw */
export function valdnUserPw(value) {
  let _inputVal = value,
    valdnPW = isStrongPassword(_inputVal, {
      minLength: 8,
      minLowercase: 1,
      minUppercase: 1,
      minNumbers: 1,
      minSymbols: 0,
      /*
            returnScore: false, 
            pointsPerUnique: 1, 
            pointsPerRepeat: 0.5, 
            pointsForContainingLower: 10, 
            pointsForContainingUpper: 10, 
            pointsForContainingNumber: 10, 
            pointsForContainingSymbol: 10
            */
    }),
    // valdnType = validator.isAlphanumeric(_inputVal),
    valdnAscii = isAscii(_inputVal),
    valdnAsciiVisible = matches(_inputVal, /^[\x20-\x7E]+$/),
    valdnLength = isLength(_inputVal, { min: 8, max: 20 }),
    valdnEmpty = isEmpty(_inputVal);

  if (valdnAscii && valdnAsciiVisible && valdnPW && valdnLength && !valdnEmpty) {
    /* console.log('All True'); */
    return true;
  } else {
    /* console.log('False'); */
    return false;
  }
}
/* valdnTextRequired */
export function valdnTextRequired(value) {
  let _inputVal = value,
    valdnEmpty = isEmpty(_inputVal);

  if (!valdnEmpty) {
    // console.log('Text Required True');
    return true;
  } else {
    // console.log('Text Required False');
    return false;
  }
}
/* valdnTextMinMaxRequired */
export function valdnTextMinMaxRequired(value, lengthMin, lengthMax) {
  let _inputVal = value,
    valdnLength,
    valdnEmpty = isEmpty(_inputVal);

  if (lengthMin > 0 && lengthMax > 0) {
    valdnLength = isLength(_inputVal, { min: lengthMin, max: lengthMax });
  } else if (lengthMin == -1) {
    valdnLength = isLength(_inputVal, { max: lengthMax });
  } else if (lengthMax == -1) {
    valdnLength = isLength(_inputVal, { min: lengthMin });
  }

  if (valdnLength && !valdnEmpty) {
    // console.log('Text Required True');
    return true;
  } else {
    // console.log('Text Required False');
    return false;
  }
}
/* valdnPwRequired */
export function valdnPwRequired(value) {
  let _inputVal = value,
    valdnEmpty = isEmpty(_inputVal);

  if (!valdnEmpty) {
    // console.log('Password Required True');
    return true;
  } else {
    // console.log('Password Required False');
    return false;
  }
}
/* valdnEmailRequired */
export function valdnEmailRequired(value) {
  let _inputVal = value,
    _localPartVal = value.split('@')[0],
    valdnEmail = isEmail(
      _inputVal /*, {
            host_blacklist: ['domain.test']
        }*/
    ),
    valdnEmailLocal = isWhitelisted(
      _localPartVal,
      'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789.+-_'
    ),
    valdnEmpty = isEmpty(_inputVal);

  // console.log('value.length', value.length);

  if (valdnEmail && valdnEmailLocal && !valdnEmpty) {
    // console.log('Email Required True');
    return true;
  } else {
    // console.log('Email Required False');
    return false;
  }
}
/* valdnNumRequired */
export function valdnNumRequired(value) {
  let _inputVal = value,
    valdnNum = isNumeric(_inputVal),
    valdnEmpty = isEmpty(_inputVal);

  if (valdnNum && !valdnEmpty) {
    // console.log('Number Required True');
    return true;
  } else {
    // console.log('Number Required False');
    return false;
  }
}
/* valdnNumMinMaxRequired */
export function valdnNumMinMaxRequired(value, valMin, valMax, stepType, stepVal) {
  let _inputVal = value,
    _stepVal = stepVal,
    valdnNum = isNumeric(_inputVal),
    valdnEmpty = isEmpty(_inputVal),
    valdnByType,
    valdnByStep;

  if (stepType == 'Float') {
    if (valMin > -1 && valMax > -1) {
      valdnByType = isFloat(_inputVal, { min: valMin, max: valMax });
    } else if (valMin == -1) {
      valdnByType = isFloat(_inputVal, { max: valMax });
    } else if (valMax == -1) {
      valdnByType = isFloat(_inputVal, { min: valMin });
    }
  } else {
    if (valMin > -1 && valMax > -1) {
      valdnByType = isInt(_inputVal, { min: valMin, max: valMax });
    } else if (valMin == -1) {
      valdnByType = isInt(_inputVal, { max: valMax });
    } else if (valMax == -1) {
      valdnByType = isInt(_inputVal, { min: valMin });
    }
  }

  if (_inputVal % _stepVal == 0) {
    valdnByStep = true;
  } else {
    valdnByStep = false;
  }

  if (valdnNum && valdnByType && valdnByStep && !valdnEmpty) {
    // console.log('Number Required True');
    return true;
  } else {
    // console.log('Number Required False');
    return false;
  }
}
/* valdnTelRequired */
export function valdnTelRequired(value) {
  let telVal = value ?? '';
  return telVal.length < 51 && /^\+[1-9][0-9]{0,2}[0-9#-]*$/.test(telVal);
}
/* valdnDateRequired */
export function valdnDateRequired(value) {
  let _inputVal = value,
    valdnDate = isDate(_inputVal),
    valdnEmpty = isEmpty(_inputVal);

  if (valdnDate && !valdnEmpty) {
    // console.log('Date Required True');
    return true;
  } else {
    // console.log('Date Required False');
    return false;
  }
}
/* valdnDateRequired */
export function valdnDateMinMaxRequired(value, valMin, valMax) {
  let _inputVal = value,
    _valMin = valMin,
    _valMax = valMax,
    valdnRangeMin = isAfter(_inputVal, _valMin) || _inputVal === _valMin,
    valdnRangeMax = isBefore(_inputVal, _valMax) || _inputVal === _valMax,
    valdnDate = isDate(_inputVal),
    valdnEmpty = isEmpty(_inputVal);

  // console.log('valdnRangeMin: ' + valdnRangeMin);
  // console.log('valdnRangeMax ' + valdnRangeMax);

  if (valdnDate && valdnRangeMin && valdnRangeMax && !valdnEmpty) {
    // console.log('Date Required True');
    return true;
  } else {
    // console.log('Date Required False');
    return false;
  }
}
/* valdnCertIDRequired */
export function valdnCertIDRequired(value) {
  let _inputVal = value,
    valdnEmpty = isEmpty(_inputVal);

  /* validate if the string starts with XL- or XT- */
  let strRuleStart, strRuleNum;
  function valdnStrRule() {
    // console.log(_inputVal.length);

    /* valid string starts with */
    if (
      _inputVal.charAt(0) === 'X' &&
      (_inputVal.charAt(1) === 'L' || _inputVal.charAt(1) === 'T') &&
      _inputVal.charAt(2) === '-'
    ) {
      strRuleStart = true;
    } else {
      strRuleStart = false;
    }

    /* valid string length and number */
    if (_inputVal.length === 15) {
      let valdnNumCount = 0;

      for (let i = 3; i < _inputVal.length; i++) {
        let valdnNum = isNumeric(_inputVal.charAt(i));

        if (!valdnNum) {
          valdnNumCount = valdnNumCount - 1;
        }
      }
      // console.log('valdnNumCount: ' + valdnNumCount);

      if (valdnNumCount === 0) {
        strRuleNum = true;
      } else {
        strRuleNum = false;
      }
    } else {
      strRuleNum = false;
    }
    // console.log('strRuleStart: ' + strRuleStart + ' / strRuleNum: ' + strRuleNum);
  }
  valdnStrRule();

  if (strRuleStart && strRuleNum && !valdnEmpty) {
    // console.log('CertID Required True');
    return true;
  } else {
    // console.log('CertID Required False');
    return false;
  }
}

/* valdnRadioRequired */
export function valdnRadioRequired(radioGroup) {
  let thisRadioGroup = radioGroup,
    radioItemChecked = radioGroup.find('input[type="radio"]:checked');

  if (radioItemChecked.length > 0) {
    // console.log('Radio Checked True');
    return true;
  } else {
    // console.log('Radio Checked False');
    return false;
  }
}


/* form-wrapper-fit */
export function wrapFit(targetWrap) {
  targetWrap.removeClass('unfit');
  targetWrap.addClass('fit');
}
export function wrapUnfit(targetWrap) {
  targetWrap.removeClass('fit');
  targetWrap.addClass('unfit');
}

export function debounce(fn, delay = 300) {
  let timer = null;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}